import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Pedido`
const API_ENDPOINT_DEVOLUCION = `${CONS.API_ENDPOINT_BACK_NODE}/ventas`

export function buscarPorUsuario(idUsuario, search) {
  return http.get(`${API_ENDPOINT}/BuscarPorUsuario/${idUsuario}/${search}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener los pedidos.',
      tipoError: 'pedidos'
    }
  })
}

export function actualizar(pedido) {
  return http.put(API_ENDPOINT, pedido)
}

export function insertar(pedido) {
  return http.post(API_ENDPOINT, pedido)
}

export function actualizarItem(pedido) {
  return http.put(`${API_ENDPOINT}/ActualizarItem`, pedido)
}

export function buscarPorPedidoItem(idPedidoItem) {
  return http.get(`${API_ENDPOINT}/BuscarPorPedidoItem/${idPedidoItem}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener el pedido.',
      tipoError: 'pedidos',
      devolverNull: true
    }
  })
}

export function buscarPorIdPedido(idPedido) {
  return http.get(`${API_ENDPOINT}/BuscarPorIdPedido/${idPedido}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener el pedido.',
      tipoError: 'pedidos',
      devolverNull: true
    }
  })
}

export function actualizarItemsMultiples(pedidos) {
  return http.put(`${API_ENDPOINT}/ActualizarItemsMultiples`, pedidos)
}

export function actualizarIdPedidoEstadoItem(pedido) {
  return http.put(`${API_ENDPOINT}/ActualizarIdPedidoEstadoItem`, pedido)
}

export function BuscarTodoPedidos(search) {
  return http.get(`${API_ENDPOINT}/BuscarTodoPedidos/${search}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener los pedidos.',
      tipoError: 'pedidos'
    }
  })
}

export function buscarPorEmpresa(empid, search) {
  return http.get(`${API_ENDPOINT}/BuscarPorEmpresa/${empid}/${search}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener los pedidos.',
      tipoError: 'pedidos'
    }
  })
}

export function actualizarEstado(
  idPedido,
  idVendedor,
  disparaVendedor,
  idComprador,
  idEstadoPedido,
  cancelaDevolucion
) {
  return http.post(`${API_ENDPOINT_DEVOLUCION}/cancelacionDevolucion`, {
    idPedido,
    idVendedor,
    disparaVendedor,
    idComprador,
    idEstadoPedido,
    cancelaDevolucion
  })
}
